import styled from 'styled-components';
import { selectColor } from '@panel/commons';

const HeaderNameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ withTooltip }) => (!withTooltip ? 7 : 14)}px;
`;

const TitleStyled = styled.div`
  height: 31px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;
`;

const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SubtitleStyled = styled.div`
  width: 100%;
  height: ${({ device }) => (device === 'tablet' ? '20' : '22')}px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  color: ${selectColor('grayDarkLight')};
  margin-top: ${({ device }) => (device === 'tablet' ? '0' : '3')}px;
`;
const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

const TooltipComponent = styled.div`
  padding: 5px 8px;
  width: 216px;
  height: 30px;
  white-space: pre-wrap;
  text-align: center;
`;

const IconTooltip = styled.img`
  margin-top: 6px;
`;

export {
  HeaderNameContainer,
  TitleSection,
  TitleStyled,
  SubtitleContainer,
  SubtitleStyled,
  TooltipComponent,
  IconTooltip,
  Icon
};
